import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NullSafeJoinPipe} from '@app/shared/util/null-safe-join.pipe';
import {BannerComponent} from '@app/shared/components/banner/banner.component';
import {LocalizePipe} from '@app/shared/util/localize.pipe';
import {ProductImagePipe} from './util/product-image.pipe';
import {ResourcePathPipe} from '@app/shared/util/resource-path.pipe';
import {HasRolePipe} from '@app/shared/util/has-role.pipe';
import {ProductImageComponent} from './components/product-image/product-image.component';
import {SingleSelectionDirective} from '@app/shared/components/single-selection.directive';
import {MultiSelectionDirective} from '@app/shared/components/multi-selection.directive';
import {AdditionalSelectionDirective} from '@app/shared/components/additional-selection.directive';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import {StaticPageBlockComponent} from '@app/shared/components/static-page-block/static-page-block.component';
import {
	StaticLanguageSwitchComponent
} from '@app/shared/components/static-language-switch/static-language-switch.component';
import {
	SaveConfigurationDialogComponent
} from './components/save-configuration-dialog/save-configuration-dialog.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatDialogModule} from '@angular/material/dialog';
import {MatRadioModule} from '@angular/material/radio';
import {MatIconModule} from '@angular/material/icon';
import {ReactiveFormsModule} from '@angular/forms';
import {PickPipe} from './util/pick.pipe';
import {DistinctPipe} from './util/distinct.pipe';
import {SortPipe} from './util/sort.pipe';
import {PagedDataPipe} from '@app/shared/util/paged-data.pipe';
import {AppArticleCardComponent} from '@app/shared/components/app-article-card/app-article-card.component';
import {IsNullOrEmptyPipe} from '@app/shared/util/is-null-or-empty.pipe';


@NgModule({
	declarations: [
		NullSafeJoinPipe,
		BannerComponent,
		LocalizePipe,
		ProductImagePipe,
		ResourcePathPipe,
		HasRolePipe,
		ProductImageComponent,
		SingleSelectionDirective,
		MultiSelectionDirective,
		AdditionalSelectionDirective,
		StaticPageBlockComponent,
		StaticLanguageSwitchComponent,
		SaveConfigurationDialogComponent,
		PickPipe,
		DistinctPipe,
		PagedDataPipe,
		SortPipe,
		AppArticleCardComponent,
		IsNullOrEmptyPipe
	],
	imports: [
		CommonModule,
		MatMenuModule,
		MatButtonModule,
		MatFormFieldModule,
		MatInputModule,
		MatDialogModule,
		MatRadioModule,
		MatIconModule,
		ReactiveFormsModule
	],
	exports: [
		NullSafeJoinPipe,
		BannerComponent,
		LocalizePipe,
		ProductImagePipe,
		ResourcePathPipe,
		HasRolePipe,
		PickPipe,
		SortPipe,
		DistinctPipe,
		PagedDataPipe,
		ProductImageComponent,
		SingleSelectionDirective,
		MultiSelectionDirective,
		AdditionalSelectionDirective,
		StaticPageBlockComponent,
		StaticLanguageSwitchComponent,
		AppArticleCardComponent,
		IsNullOrEmptyPipe
	]
})
export class SharedModule {
}
